/* globals disabledLogEntry */
/* eslint-disable new-cap, camelcase */
function Debugger (
    recordControlAudit,
    recordControlDetailed,
    recordRteAudit,
    recordRteDetailed,
    recordSequencingAudit,
    recordSequencingDetailed,
    recordSequencingSimple,
    recordLookAheadAudit,
    recordLookAheadDetailed,
    version,
    includeTimestamps
) {
    /* globals Log */
    this.auditCount = 0;

    this.RecordControlAudit = recordControlAudit;
    this.RecordControlDetailed = recordControlDetailed;
    if (this.RecordControlDetailed) {
        this.RecordControlAudit = true;
    }

    this.RecordRteAudit = recordRteAudit;
    this.RecordRteDetailed = recordRteDetailed;
    if (this.RecordRteDetailed) {
        this.RecordRteAudit = true;
    }

    this.RecordSequencingAudit = recordSequencingAudit;
    this.RecordSequencingDetailed = recordSequencingDetailed;
    if (this.RecordSequencingDetailed) {
        this.RecordSequencingAudit = true;
    }

    this.RecordLookAheadAudit = recordLookAheadAudit;
    this.RecordLookAheadDetailed = recordLookAheadDetailed;
    if (this.RecordLookAheadDetailed) {
        this.RecordLookAheadAudit = true;
    }

    this.RecordSequencingSimple = recordSequencingSimple;

    // Functions
    /* eslint-disable no-use-before-define */
    this.Write = Debugger_Write;
    this.AssertError = Debugger_AssertError;
    this.DataIsAvailable = Debugger_DataIsAvailable;
    this.ShowAllAvailableData = Debugger_ShowAllAvailableData;

    this.WriteControlAudit = Debugger_WriteControlAudit;
    this.WriteControlDetailed = Debugger_WriteControlDetailed;
    this.WriteRteAudit = Debugger_WriteRteAudit;
    this.WriteRteAuditReturnValue = Debugger_WriteRteAuditReturnValue;
    this.WriteRteDetailed = Debugger_WriteRteDetailed;

    this.WriteSequencingAudit = Debugger_WriteSequencingAudit;
    this.WriteSequencingAuditReturnValue = Debugger_WriteSequencingAuditReturnValue;
    this.WriteSequencingDetailed = Debugger_WriteSequencingDetailed;

    this.WriteSequencingSimpleAudit = Debugger_WriteSequencingSimpleAudit;
    this.WriteSequencingSimpleReturnValue = Debugger_WriteSequencingSimpleReturnValue;
    this.WriteSequencingSimpleDetailed = Debugger_WriteSequencingSimpleDetailed;

    this.WriteLookAheadAudit = Debugger_WriteLookAheadAudit;
    this.WriteLookAheadAuditReturnValue = Debugger_WriteLookAheadAuditReturnValue;
    this.WriteLookAheadDetailed = Debugger_WriteLookAheadDetailed;

    this.GetErrors = Debugger_GetErrors;
    this.GetSerializedLogEntry = Debugger_GetSerializedLogEntry;
    this.GetSerializedLog = Debugger_GetSerializedLog;
    /* eslint-enable no-use-before-define */

    this.log = new Log(version, includeTimestamps);

    this.currentControlEntry = null;
    this.currentRunTimeEntry = null;
    this.currentSequencingEntry = null;
    this.currentLookAheadEntry = null;
    this.currentSequencingSimpleEntry = null;

    this.ErrorDataExists = false;
    this.ShowDebugLogAtExit = false;

    this.version = version;
    this.includeTimestamps = includeTimestamps;
}

Debugger.prototype.display = function () {
    window.open("debugger.html", "_blank", "toolbar=yes,location=yes,directories=yes,resizable=yes,scrollbars=yes");
};

// TODO: should we just remove this now?
function Debugger_Write () {
    this.AssertError("Debug.Write function is deprecated. Remove all calls.");
}

function Debugger_AssertError (arg, errorCondition) {
    var message;

    if (typeof errorCondition === "undefined" || errorCondition === null || errorCondition === true) {
        message = "Code Asserted Error-" + arg;

        Debug.WriteControlAudit(message);
        if (typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.log(message);
        }
    }
}

function Debugger_DataIsAvailable () {
    var dataIsAvailable = this.RecordControlAudit
        || this.RecordControlDetailed
        || this.RecordRteAudit
        || this.RecordRteDetailed
        || this.RecordSequencingAudit
        || this.RecordSequencingDetailed
        || this.RecordLookAheadAudit
        || this.RecordLookAheadDetailed
        || this.ErrorDataExists;

    return dataIsAvailable;
}

function Debugger_ShowAllAvailableData () {
    this.display();
}

//
// Control
//
function Debugger_WriteControlAudit (args, parentEntry, isError) {
    if (isError) {
        this.ErrorDataExists = true;
    }

    if (this.RecordControlAudit || isError) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentControlEntry = this.log.startNew("c", args);
        }
        else {
            this.currentControlEntry = parentEntry.startNew("c", args);
        }

        this.currentControlEntry.setAttribute("id", this.auditCount += 1);

        return this.currentControlEntry;
    }

    return disabledLogEntry;
}

/*
function Debugger_WriteControlAuditReturnValue (str, parentEntry, isError) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentControlEntry === null) {
        return;
    }

    if (this.RecordControlAudit || isError) {
        this.currentControlEntry.setReturn(str);
    }

    if (parentEntry !== null && parentEntry !== undefined) {
        this.currentControlEntry = parentEntry;
    }
    else {
        this.AssertError("Debugger_WriteControlAuditReturnValue() called without parentEntry");
    }
}
*/

function Debugger_WriteControlDetailed (str, parentEntry, isError) {
    var errorEntry;

    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentControlEntry === null) {
        return;
    }

    if (isError) {
        errorEntry = this.WriteControlAudit("Control ERROR", null, true);
        errorEntry.write(str);
    }
    else if (this.RecordControlDetailed) {
        if (typeof parentEntry !== "undefined" && parentEntry !== null) {
            parentEntry.write(str);
        }
        else {
            this.currentControlEntry.write(str);
        }
    }
}

//
// RunTime
//
function Debugger_WriteRteAudit (args, parentEntry) {
    if (this.RecordRteAudit) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentRunTimeEntry = this.log.startNew("rt", args);
        }
        else {
            this.currentRunTimeEntry = parentEntry.startNew("rt", args);
        }

        this.currentRunTimeEntry.setAttribute("id", this.auditCount += 1);

        return this.currentRunTimeEntry;
    }

    return disabledLogEntry;
}

function Debugger_WriteRteAuditReturnValue (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentRunTimeEntry === null) {
        return;
    }

    if (this.RecordRteAudit) {
        this.currentRunTimeEntry.setReturn(str);
    }

    if (typeof parentEntry !== "undefined" && parentEntry !== null) {
        this.currentRunTimeEntry = parentEntry;
    }
    else {
        // this.AssertError("Debugger_WriteRteAuditReturnValue() called without parentEntry");
    }
}

function Debugger_WriteRteDetailed (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentRunTimeEntry === null) {
        return;
    }

    if (this.RecordRteDetailed) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentRunTimeEntry.write(str);
        }
        else {
            parentEntry.write(str);
        }
    }
}

//
// Sequencing
//
function Debugger_WriteSequencingAudit (args, parentEntry) {
    if (this.RecordSequencingAudit) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentSequencingEntry = this.log.startNew("s", args);
        }
        else {
            this.currentSequencingEntry = parentEntry.startNew("s", args);
        }

        this.currentSequencingEntry.setAttribute("id", this.auditCount += 1);

        return this.currentSequencingEntry;
    }

    return disabledLogEntry;
}

function Debugger_WriteSequencingAuditReturnValue (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentSequencingEntry === null) {
        return;
    }

    if (this.RecordSequencingAudit) {
        this.currentSequencingEntry.setReturn(str);
    }

    if (typeof parentEntry !== "undefined" && parentEntry !== null) {
        this.currentSequencingEntry = parentEntry;
    }
    else {
        this.AssertError("Debugger_WriteSequencingAuditReturnValue() called without parentEntry");
    }
}

function Debugger_WriteSequencingDetailed (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentSequencingEntry === null) {
        return;
    }

    if (this.RecordSequencingDetailed) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentSequencingEntry.write(str);
        }
        else {
            parentEntry.write(str);
        }
    }
}

function Debugger_WriteSequencingSimpleAudit (args, parentEntry) {
    if (this.RecordSequencingSimple) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentSequencingSimpleEntry = this.log.startNew("ss", args);
        }
        else {
            this.currentSequencingSimpleEntry = parentEntry.startNew("ss", args);
        }

        this.currentSequencingSimpleEntry.setAttribute("id", this.auditCount += 1);

        return this.currentSequencingSimpleEntry;
    }

    return disabledLogEntry;
}

function Debugger_WriteSequencingSimpleReturnValue (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentSequencingSimpleEntry === null) {
        return;
    }

    if (this.RecordSequencingSimple) {
        this.currentSequencingSimpleEntry.setReturn(str);
    }

    if (typeof parentEntry !== "undefined" && parentEntry !== null) {
        this.currentSequencingSimpleEntry = parentEntry;
    }
    else {
        this.AssertError("Debugger_WriteLookAheadAuditReturnValue() called without parentEntry");
    }
}

function Debugger_WriteSequencingSimpleDetailed (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentSequencingSimpleEntry === null) {
        return;
    }

    if (this.RecordSequencingSimple) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentSequencingSimpleEntry.write(str);
        }
        else {
            parentEntry.write(str);
        }
    }
}

//
// Look Ahead
//
function Debugger_WriteLookAheadAudit (args, parentEntry) {
    if (this.RecordLookAheadAudit) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentLookAheadEntry = this.log.startNew("l", args);
        }
        else {
            this.currentLookAheadEntry = parentEntry.startNew("l", args);
        }

        this.currentLookAheadEntry.setAttribute("id", this.auditCount += 1);

        return this.currentLookAheadEntry;
    }

    return disabledLogEntry;
}

function Debugger_WriteLookAheadAuditReturnValue (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentLookAheadEntry === null) {
        return;
    }

    if (this.RecordLookAheadAudit) {
        this.currentLookAheadEntry.setReturn(str);
    }

    if (typeof parentEntry !== "undefined" && parentEntry !== null) {
        this.currentLookAheadEntry = parentEntry;
    }
    else {
        this.AssertError("Debugger_WriteLookAheadAuditReturnValue() called without parentEntry");
    }
}

function Debugger_WriteLookAheadDetailed (str, parentEntry) {
    // Only possibility for null is when dynamically turning on debugging at runtime
    if (this.currentLookAheadEntry === null) {
        return;
    }

    if (this.RecordLookAheadDetailed) {
        if (typeof parentEntry === "undefined" || parentEntry === null) {
            this.currentLookAheadEntry.write(str);
        }
        else {
            parentEntry.write(str);
        }
    }
}

function Debugger_GetErrors () {
    var entries = this.log.entries,
        result = [],
        i;

    for (i = 0; i < entries.length; i += 1) {
        if (entries[i].recordType === "c" && entries[i].functionName === "Control ERROR") {
            result.push(entries[i].children[0].text);
        }
    }

    return result;
}

function Debugger_GetSerializedLogEntry (entry) {
    var xmlEntry = new XmlElement(entry.recordType),
        attribute,
        i;

    if (this.includeTimestamps) {
        xmlEntry.AddAttribute("ts", entry.formatTimestampForLog());
    }

    if (entry.recordType === "i" || entry.recordType === "e") {
        xmlEntry.AddElement(entry.xmlEscapeText());
    }
    else {
        if (this.includeTimestamps) {
            xmlEntry.AddAttribute("ts_utc", entry.formatTimestampForLog(true));
        }

        xmlEntry.AddAttribute("f", entry.functionName);

        for (attribute in entry.attributes) {
            if (entry.attributes.hasOwnProperty(attribute)) {
                xmlEntry.AddAttribute(attribute, entry.attributes[attribute]);
            }
        }

        if (entry.returnValue !== null) {
            xmlEntry.AddAttribute("r", entry.returnValue.value);
            if (this.includeTimestamps) {
                xmlEntry.AddAttribute("et", entry.returnValue.elapsedTime);
            }
        }
    }

    for (i = 0; i < entry.children.length; i += 1) {
        xmlEntry.AddElement(
            this.GetSerializedLogEntry(entry.children[i])
        );
    }

    return xmlEntry;
}

function Debugger_GetSerializedLog () {
    /* globals XmlElement */
    var rootElement = new XmlElement("scp-log"),
        i;

    rootElement.AddAttribute("version", this.version);
    rootElement.AddAttribute("browser", this.log.browser);

    for (i = 0; i < this.log.entries.length; i += 1) {
        rootElement.AddElement(
            this.GetSerializedLogEntry(this.log.entries[i])
        );
    }

    return "<?xml version=\"1.0\"?>" + rootElement.toString();
}
